<div [innerHTML]="value"></div>
